import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getPlanLabel } from '../core/billingPlans';
import { PLAN_IDS } from '../core/subscriptionManager';
import { authFetch } from '../api';

const useAuthStore = create(
  persist(
    (set) => ({
      isAuthenticated: false,
      isCheckingSession: true,
      user: null,
      planId: PLAN_IDS.FREE,
      currentPlan: getPlanLabel(PLAN_IDS.FREE),
      activeSubscription: null,
      login: (userData) => set({
        isAuthenticated: true,
        isCheckingSession: false,
        user: userData
      }),
      logout: async () => {
        localStorage.removeItem('user_id');

        set({
          isAuthenticated: false,
          isCheckingSession: false,
          user: null,
          planId: PLAN_IDS.FREE,
          currentPlan: getPlanLabel(PLAN_IDS.FREE),
          activeSubscription: null
        });

        try {
          await authFetch('sign-out', {
            method: 'POST',
            body: JSON.stringify({})
          });
        } catch {
          // Stan lokalny został już bezpiecznie wyczyszczony.
        }
      },
      setSubscription: (subscription) => {
        const planId = subscription?.planId ?? PLAN_IDS.FREE;

        set({
          planId,
          currentPlan: getPlanLabel(planId),
          activeSubscription: subscription ?? null
        });
      },
      setPlan: () => {},
      setCheckingSession: (value) => set({ isCheckingSession: value })
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user
      })
    }
  )
);

export default useAuthStore;